@if (form) {
  <div
    class="form-container"
    [ngClass]="{ 'no-error': !hasErrors(), 'has-error': hasErrors() }"
  >
    @if (label) {
      <mat-label
        [ngClass]="{ focused: isFocused, 'has-error': hasErrors() }"
        class="form-label"
        >{{ label }}</mat-label
      >
    }
    @if (mergeTagGroups.length > 0) {
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="4px"
        class="merge-tag-container"
      >
        <mat-form-field
          appearance="outline"
          floatLabel="always"
          class="merge-tag-field extra-compact-field"
          subscriptSizing="dynamic"
        >
          <input
            type="text"
            placeholder="Search merge tags..."
            matInput
            [formControl]="mergeTagControl"
            [matAutocomplete]="mergeTagAuto"
            aria-label="Search for a merge tag"
          />
          <mat-autocomplete
            #mergeTagAuto="matAutocomplete"
            [displayWith]="displayMergeTag"
            (optionSelected)="onMergeTagSelected($event.option.value)"
          >
            @for (group of filteredMergeTagGroups | async; track group) {
              <div class="select-group">
                <p>{{ group.name }}</p>
                @for (tag of group.items; track tag) {
                  <mat-option [value]="tag">{{ tag.name }}</mat-option>
                }
                <mat-divider></mat-divider>
              </div>
            }
          </mat-autocomplete>
        </mat-form-field>
        <button
          type="button"
          class="merge-tag-copy-btn"
          mat-icon-button
          aria-label="Copy credential merge tag"
          (click)="copySelectedMergeTag()"
          [disabled]="!selectedMergeTag"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    }
    @if (credentialItems.length > 0) {
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="4px"
        class="merge-tag-container credential-merge-tag-container"
      >
        <mat-form-field
          appearance="outline"
          floatLabel="always"
          class="merge-tag-field extra-compact-field"
          subscriptSizing="dynamic"
        >
          <input
            type="text"
            placeholder="Credential"
            matInput
            [formControl]="credentialControl"
            [matAutocomplete]="credentialAuto"
            aria-label="Search for a credential"
          />
          <mat-autocomplete
            #credentialAuto="matAutocomplete"
            [displayWith]="displayMergeTag"
            (optionSelected)="
              onCredentialDefinitionSelected($event.option.value)
            "
          >
            @for (item of filteredCredentialItems | async; track item) {
              <mat-option [value]="item">{{ item.name }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          floatLabel="always"
          class="merge-tag-field extra-compact-field"
          subscriptSizing="dynamic"
        >
          <input
            type="text"
            placeholder="Search ?"
            matInput
            [formControl]="credentialFieldControl"
            [matAutocomplete]="credentialFieldAuto"
            [disabled]="!selectedCredentialDefinition"
            aria-label="Search for a credential field"
          />
          <mat-autocomplete
            #credentialFieldAuto="matAutocomplete"
            [displayWith]="displayMergeTag"
            (optionSelected)="onCredentialFieldSelected($event.option.value)"
          >
            @for (item of filteredCredentialFields | async; track item) {
              <mat-option [value]="item">{{ item.name }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <button
          type="button"
          class="merge-tag-copy-btn"
          mat-icon-button
          (click)="copySelectedMergeTag()"
          [disabled]="!selectedCredentialField"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    }
    <div class="content-container">
      @if (show) {
        <ckeditor
          fxFlex="99"
          [editor]="editor"
          [ngModel]="data"
          [config]="config"
          (ready)="onReady($event)"
          (change)="onChange($event)"
          (blur)="blur.emit()"
        >
        </ckeditor>
      }
      @if (hasErrors()) {
        <mat-error [@elementSlideDown]>
          {{ capitalizedField }} is required
        </mat-error>
      }
    </div>
  </div>
}
